<template>
  <v-row justify="center">
    <v-dialog
      :value="true"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('product') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="model.name"
                    :label="$t('name')"
                    :rules="rules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="model.cost"
                    :label="$t('cost_price')"
                    :rules="rules"
                  />
                </v-col>
                <v-col cols="6">
                  <base-paginated-select
                    endpoint="fees"
                    :selected="model.fees"
                    :label="$t('fees')"
                    item-text="name"
                    selected-item-text="name"
                    multiple
                    @value-change="updateFee"
                  />
                </v-col>
                <v-col cols="6">
                  <base-paginated-select
                    endpoint="product-groups"
                    :selected="model.product_group"
                    :label="$t('product_group')"
                    item-text="name"
                    selected-item-text="name"
                    :rules="rules"
                    @value-change="updateProductGroup"
                  />
                </v-col>
                <v-col cols="6">
                  <base-paginated-select
                    endpoint="countries"
                    :selected="model.country_from"
                    :label="`${$t('country')} ${$t('from')}`"
                    item-text="full_name"
                    selected-item-text="full_name"
                    :rules="rules"
                    @value-change="updateCountryFrom"
                  />
                </v-col>
                <v-col cols="6">
                  <base-paginated-select
                    endpoint="countries"
                    :selected="model.country_to"
                    :label="`${$t('country')} ${$t('to')}`"

                    item-text="full_name"
                    selected-item-text="full_name"
                    :rules="rules"
                    @value-change="updateCountryTo"
                  />
                </v-col>
                <v-col
                  cols="4"
                >
                  <v-text-field
                    v-model="model.height"
                    :rules="rules"
                    type="number"
                    :label="$t('height')"
                    suffix="cm"
                  />
                </v-col>
                <v-col
                  cols="4"
                >
                  <v-text-field
                    v-model="model.width"
                    :rules="rules"
                    type="number"

                    :label="$t('width')"
                    suffix="cm"
                  />
                </v-col>
                <v-col
                  cols="4"
                >
                  <v-text-field
                    v-model="model.length"
                    :rules="rules"
                    type="number"

                    :label="$t('length')"
                    suffix="cm"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="model.weight_from"
                    :rules="rules"
                    type="number"

                    :label="`${$t('weight')} ${$t('from')}`"
                    suffix="g"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="model.weight_to"
                    type="number"
                    :rules="rules"

                    :label="`${$t('weight')} ${$t('to')}`"
                    suffix="g"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            {{ $t('close') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="validate"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { REQUIRED } from '@/utils/rules'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      product: {
        type: Object,
        default: () => ({}),
      },
      agreementId: {
        type: Number,
        default: null,
      },
    },
    data: () => ({
      model: {},
    }),
    computed: {
      rules () {
        return [REQUIRED]
      },
    },

    created: function () {
      this.model = this.$_.clone(this.product)
    },
    methods: {
      closeDialog: function () {
        this.$emit('close')
      },
      saveDialog: function (response) {
        this.$emit('save', response)
      },
      updateFee: function (val) {
        this.model.fees = val
      },
      updateProductGroup: function (val) {
        this.model.product_group = val
      },
      updateCountryFrom: function (val) {
        this.model.country_from = val
      },
      updateCountryTo: function (val) {
        this.model.country_to = val
      },
      save () {
        this.saveDialog()
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.updateProduct()
        }
      },
      updateProduct () {
        this.saveDialog(this.model)
      },

    },
  }
</script>
